<div fxFlexLayout="row" class="section" fxFill>
  <div fxFlex="1 1 5%"></div>

  <div fxLayout="column" fxFlex="1 1 90%">

    <div class="section-title mat-typography">
      <a href='#' routerLink='/models'
        fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon svgIcon="gz-model"></mat-icon>
        <h2>Latest models</h2>
      </a>
    </div>

    <div *ngIf='!models || models.length === 0' class='mat-typography'>
      <h3>There are no models yet.</h3>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center">
      <gz-item-card class="card"
        fxFlex.xs="100%"
        fxFlex.gt-xs="50%"
        fxFlex.gt-md="25%"
        [resource]="model" type="models" *ngFor="let model of models">
      </gz-item-card>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <a mat-raised-button color="primary" routerLink='/models'
        class="more-button">
        Discover more
      </a>
    </div>
  </div>
</div>

<div fxFlexLayout="row" class="section" fxFill>
  <div fxFlex="1 1 5%"> </div>

  <div fxLayout="column" fxFlex="1 1 90%">

    <div class="section-title mat-typography">
      <a href='#' routerLink='/worlds'
        fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon svgIcon="gz-world"></mat-icon>
        <h2>Latest worlds</h2>
      </a>
    </div>

    <div *ngIf='!worlds || worlds.length === 0' class='mat-typography'>
      <h3>There are no worlds yet.</h3>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center">
      <gz-item-card class="card"
        fxFlex.xs="100%"
        fxFlex.gt-xs="50%"
        fxFlex.gt-md="25%"
        [resource]="world" type="worlds" *ngFor="let world of worlds">
      </gz-item-card>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <a mat-raised-button color="primary" routerLink='/worlds'
        class="more-button">
        Discover more
      </a>
    </div>
  </div>
</div>

<div fxFlexLayout="row" class="section" fxFill>
  <div fxFlex="1 1 5%"> </div>

  <div fxLayout="column" fxFlex="1 1 90%">

    <div class="section-title mat-typography">
      <a href='#' routerLink='/collections'
         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon>collections</mat-icon>
        <h2>Latest collections</h2>
      </a>
    </div>

    <div *ngIf='!collections || collections.length === 0' class='mat-typography'>
      <h3>There are no collections yet.</h3>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center">
      <gz-item-card class="card"
        fxFlex.xs="100%"
        fxFlex.gt-xs="50%"
        fxFlex.gt-md="25%"
        [resource]="collection" type="collections" *ngFor="let collection of collections">
      </gz-item-card>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <a mat-raised-button color="primary" routerLink='/collections'
        class="more-button">
        Discover more
      </a>
    </div>
  </div>
</div>
